import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAnalytics from 'vue-analytics';


import _ from 'lodash'
import VueResource from 'vue-resource';

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueI18n from 'vue-i18n'
import marked from 'marked'

import langs from './langs.js';

import CategorySpan from './components/Partials/CategorySpan.vue'
import BusinessSpan from './components/Partials/BusinessSpan.vue'

library.add(fas, far, fab)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('category-span', CategorySpan);
Vue.component('business-span', BusinessSpan);

Vue.use(VueAnalytics, {
    id: "UA-193248206-1",
    router: router
});

Vue.use(VueResource);
Vue.use(VueI18n);

var i18n = new VueI18n({
	locale: 'it',
	fallbackLocale: 'it',
	messages: langs.messages
});

Vue.config.productionTip = false

var asrbc = {
	data: {},
	wait_page: false,
	environment: false,
	errors: [],
	uid: 'asrbc_',
	s: function(k, value) {
		if(this.data[k] == undefined)
			Vue.set(this.data, k, false);
		this.data[k] = value;
		this.localStore();
		return this.data[k];
	},
	u: function(k) {
		localStorage.removeItem(this.uid + k);
		delete this.data[k];
	},
	g: function(k) {
		return this.data[k];
	},
	user: function() {
		return this.g('jwt');
	},
	localStore: function() {
		for(var k in this.data)
			window.localStorage.setItem(this.uid + k, JSON.stringify(this.data[k]));
			//window.localStorage.setItem(this.uid + k, btoa(JSON.stringify(this.data[k])));
	},
	localLoad: function() {
		var storage = window.localStorage;
		for(var a in storage) {
			if(typeof storage[a] != 'function') {
				if( a.indexOf(this.uid) != -1 ) {
					var innerKey = a.replace(this.uid, '');
					try {
						this.s(innerKey, JSON.parse(storage[a]));
					} catch {

					}
					// this.s(innerKey, JSON.parse(atob(storage[a])));
				}
			}
		}
	},
	destroy: function() {
		_.each(_.keys(this.data), function(a) {
			localStorage.removeItem(this.uid + a);
		}.bind(this));
		return true;
	},
	init: function() {
		this.localLoad();
	},
	bearer: function() {
		return btoa(btoa(this.g('bearer')))
	}
}

asrbc.init();

// Authorization Checker
Vue.http.interceptors.push(function(request, next) {
	
	this.$root.loading = true;
	
	if(asrbc.user())
		Vue.http.headers.common['Authorization'] = 'Bearer ' + asrbc.user();
	else
		Vue.http.headers.common['Authorization'] = '';

	next();

	// Watcher for `net-wait` status.
	return function(response) {
		this.$root.loading = false;
	};

});

router.beforeEach(function(to, from, next) {

	var canGo = true;
	var amoutOfMatched = to.matched.length;

	if(to.matched[ amoutOfMatched - 1 ] != undefined && to.matched[amoutOfMatched - 1 ].meta != undefined) {
		if(to.matched[ amoutOfMatched - 1 ].meta.auth) {
			if(!asrbc.user()) {
				canGo = false;
				next({ name: 'UserLogin', query: { redirectTo: window.location.hash.replace('#', '') } });
			}
		}
	}

	if(asrbc.g('active_sub') == false) {
		if(to.matched[ amoutOfMatched - 1 ].meta.expired) {
			canGo = true;
		} else {
			canGo = false;
			next({ name: 'AccountExpired' });
		}
	}

	if(to.matched[ amoutOfMatched - 1 ].meta)
		var meta = to.matched[ amoutOfMatched - 1 ].meta;

	if(canGo == true)
		next();

});

Vue.mixin({
	filters: {
		lowerCase: function(a) {
			return a.toLowerCase();
		}
	},
	data: function() {
		return {}
	},
	created: function() {
	},
	computed: {
		asr: function() {
			return this.$root.asrbc;
		},
		uri: function() {
			return 'https://apibc.asroma.com/api/';
			return 'https://asrbc.mndrn.cloud/api/';
		},
		cdn: function() {
			return 'https://apibc.asroma.com/';
			return 'https://asrbc.mndrn.cloud/';
		},
		env: function() {
			return this.$root.environment;
		},
		logged_user: function() {
			if(this.env) return this.$root.environment.user;
		},
		language: function() {
			return this.$i18n.locale;
		}
	},
	methods: {
		marked: function(t) {

			var renderer = new marked.Renderer();

			renderer.link = function( href, title, text ) {
			  return '<a target="_blank" href="'+ href +'" title="' + title + '" class="text-dark" style="text-decoration: underline">' + text + '</a>';
			}

			return marked(t, { renderer:renderer });

		}
	}
});

new Vue({
	router,
	i18n,
	render: function(h) { return h(App) },
	data: {
		loading: false,
		lang: 'it',
		environment: false,
		asrbc: asrbc,
		modal: {
			cookie: false,
			link_two: false,
			link_four: false
		}
	},
	watch: {
		'$i18n.locale': {
			deep: true,
			handler: function() {
				this.asrbc.s('lang', this.$i18n.locale);
				if(asrbc.user())
					this.LoadEnv();
			}
		}
	},
	methods: {
		LoadEnv: function(then) {

			this.$http.post(this.uri + 'users.whoami', { language: this.$i18n.locale }).then(function(data) {

				this.environment = data.data;
				this.asr.environment = this.environment;
				this.asr.s('active_sub', data.data.active_sub);

				if(then) {
					then();
				}

			}, function() {
				this.UserLogout();
			});

		},
		UserLogout: function() {

			this.asr.destroy();

			_.delay(function() {
				location.reload();
			}.bind(this), 100);

		}

	},
	created: function() {

		// console.log(this.$route);
		if(asrbc.g('lang') && this.$route.query.lang == undefined)
			this.$i18n.locale = asrbc.g('lang');
		else if(this.$route.query.lang != undefined)
			this.$i18n.locale = this.$route.query.lang;

		if(asrbc.user())
			this.LoadEnv();

		this.$on('envRefresh', function() {
			this.LoadEnv();
		});
		
	}
}).$mount('#app')

/*new Vue({
	router,
	render: function(h) { return h(App) },
	data: {
		loading: false,
		lang: localStorage.asromalang ? JSON.parse(localStorage.asromalang) : {id: null, name: null},
		environment: false,
		asrbc: asrbc
	},
	methods: {
		setLanguage: function(id, name) {

			this.lang = {
				id,
				name
			};

			localStorage.asromalang = JSON.stringify(this.lang);
			this.$moment.locale(id);

		},
		getLanguageFromId: function(id) {
			if (id == 'it')
				return {
					id: 'it',
					literal: 'Italiano'
				}
			return {
				id: 'en',
				literal: 'English'
			}
		},
		setLanguageFromQueryParam: function() {
			if (this.$route.query.lang && this.$route.query.lang == 'it')
				this.setLanguage('it', 'Italiano');
			if (!this.lang.id)
				this.setLanguage('en', 'English');
		},
		
		LoadEnv: function(then) {

			this.$http.post(this.uri + 'users.whoami').then(function(data) {

				this.environment = data.data;
				this.asr.environment = this.environment;

				if(then) {
					then();
				}

			}, function() {
				this.UserLogout();
			});

		},
		UserLogout: function() {

			this.asr.destroy();

			_.delay(function() {
				location.reload();
			}.bind(this), 100);

		}

	},
	created: function() {
		this.setLanguageFromQueryParam();
		if(asrbc.user())
			this.LoadEnv();

		this.$on('envRefresh', function() {
			this.LoadEnv();
		})

	},
	computed: {
		language: function() {
			return this.$route.query.lang;
		}
	},
	watch: {
		language: function() {
			this.setLanguageFromQueryParam();
		}
	}
}).$mount('#app')*/